// React Imports
import { ReactElement, useState } from "react";

// Third Party Libraries Imports
import { ColumnsType } from "antd/es/table";
import { Tooltip } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { ReactSVG } from "react-svg";

// Local Imports
import CustomSearch from "../../components/custom-search/custom-search";
import CustomTable from "../../components/custom-table/custom-table";
import BreadcrumbComponent from "../../components/breadcrumb-component/breadcrumb-component";
import CustomModal from "../../components/custom-modal/custom-modal";
import ViewEmailTemplate from "./components/view-email-tempalte";

const EmailTemplates: React.FC = (): ReactElement => {
  const navigate = useNavigate();
  const [openViewModal, setOpenViewModal] = useState<boolean>()

  const columns: ColumnsType<any> = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
      fixed: "left",
      render: (_, __, index: number) => <span>{index + 1}</span>,
    },
    {
      title: "Key",
      dataIndex: "key",
      key: "key",
      sorter: (a, b) => a.key.length - b.key.length,
      fixed: "left",
    },
    {
      title: "Subject",
      dataIndex: "subject",
      key: "subject",
      sorter: (a, b) => a.subject.length - b.subject.length,
    },
    {
      title: "Template name",
      dataIndex: "templateName",
      key: "templateName",
      sorter: (a, b) => a.templateName.length - b.templateName.length,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      sorter: (a, b) => a.isActive.length - b.isActive.length,
      filters: [
        {
          text: "Active",
          value: "active",
        },
        {
          text: "Inactive",
          value: "inactive",
        },
      ],
      render: (text) => <span className="status">{text}</span>,
    },
    {
      title: "Updated at",
      dataIndex: "updatedAt",
      key: "updatedAt",
      sorter: (a, b) => a.updatedAt.length - b.updatedAt.length,
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: () => (
        <div className="flex items-center gap-3">
          <ReactSVG src={"/images/view.svg"} onClick={() => setOpenViewModal(true)} />
          <ReactSVG
            src={"/images/edit.svg"}
            onClick={() => navigate("/email-templates/add?edit=1")}
          />
        </div>
      ),
    },
  ];

  return (
    <div className="flex flex-col">
      <div className="flex items-center justify-between">
        <BreadcrumbComponent />

        <Link
          to={"/email-templates/add"}
          className="flex flex-col md:flex-row items-center justify-center bg-blue-500 rounded-[20px] py-[10px] px-[25px] text-white border-0 cursor-pointer mb-5 decoration-transparent"
        >
          <img className=" w-[50px] md:w-[20px] m-0 md:me-2" src={"/images/white-add-square.svg"} alt="add-fund kamco" />
          <span className="hidden md:flex text-base">Add email template</span>
        </Link>
      </div>

      <div className=" mt-5 border-t-[1px] border-gray-400 rounded-lg">
        <div className="flex items-center justify-between rounded-lg bg-white py-[10px] px-5">
          <p className=" text-black-300 text-base font-bold">
            4 Email templates
          </p>
          <div className="images flex items-center">
            <CustomSearch />
            <Tooltip placement="topLeft" title="Columns settings">
              <img src={"/images/grid.svg"} alt="grid" />
            </Tooltip>
          </div>
        </div>
        <CustomTable columns={columns} data={[]} />
      </div>

      <CustomModal
        isVisible={openViewModal}
        centered
        width={900}
        showClose={false}
        onClose={() => {
          setOpenViewModal(false);
        }}
        className="edit-modal"
      >
        <div className="flex flex-col items-center justify-center">
          <ViewEmailTemplate
            onCancel={() => {
              setOpenViewModal(false);
            }}
          />
        </div>
      </CustomModal>
    </div>
  );
};

export default EmailTemplates;
